/**
 *
 * Loop throught the data object
 * and see if the value got the
 * translated value;
 *
 * @todo Implement fallback language.
 * @todo Cache translations (or make sure that React caches them which I (Stan) pre-assume).
 */

import { getLocalizedContent as l } from '@helpers/languages';

export default function translate(object, language) {
  // Loop through objects and arrays.
  for (var index in object) {
    // Check if entry is object or array.
    if (object[index] !== null && typeof object[index] == 'object') {
      // Check if object got property translated
      if (Object.prototype.hasOwnProperty.call(object[index], 'translated')) {
        // Return translated value
        object[index] = l(object[index], language);
      } else {
        // Else continue tranverse
        translate(object[index], language);
      }
    }
  }

  return Object.assign({}, object); // Make immutable
}
